// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import App from "./App.vue";

import store from "./store";
import nprogress from "./helpers/nprogress";

// Plugins
import Chartist from "chartist";
import DashboardPlugin from "./material-dashboard";

// router setup
import router from "./routes/router";

// plugin setup
Vue.use(DashboardPlugin);

// global library setup
Vue.prototype.$Chartist = Chartist;

// Vue.config.errorHandler = err => {
//   alert(`UNCAUGHT ERROR : errorHandler in main.js: ${err}`);
// };

/* eslint-disable no-new */
new Vue({
  el: "#app",
  nprogress,
  store,
  router,
  render: h => h(App)
});
